import { Input, NgModule, OnInit, Directive } from "@angular/core";
import { Dominio } from "src/app/model/dominio-operacao.model";
import { OperacaoCreditoLivre, OutrasGarantias } from "src/app/model/operacao-credito-livre.model";
import { OperacaoGarantida } from "src/app/model/operacao-garantida.model";
import { SharedModule } from "src/app/shared/shared.module";
import { AbaOutrasGarantiasComponent } from "./aba-outras-garantias.component";

//@Directive()
@NgModule({
    declarations: [AbaOutrasGarantiasComponent],
    imports: [SharedModule],
    exports: [AbaOutrasGarantiasComponent]
})
export class AbaOutrasGarantiasModule implements OnInit {
    @Input()
    public operacao: OperacaoCreditoLivre;
    @Input()
    public modoEdicao: Boolean;
    @Input()
    public modoAditivo: Boolean; 
    @Input()
    public emInclusao: Boolean;
    @Input()
    public dadosDominio: Dominio;
    @Input()
    public model: OperacaoGarantida;
    @Input()
    public modoRetificacao: Boolean;

    public outrasGarantias: OutrasGarantias[];

    ngOnInit(): void {
        this.outrasGarantias = this.operacao.outrasGarantias;
    }

    atribuiGarantia(tipoGarantia: string, i) {
        const operacaoCreditoLivre: OperacaoCreditoLivre = <OperacaoCreditoLivre>this.model;
        operacaoCreditoLivre.outrasGarantias[i].tipoGarantia = tipoGarantia;
    }
    
    adicionarGarantia() {
        const operacaoCreditoLivre: OperacaoCreditoLivre = <OperacaoCreditoLivre>this.model;
        operacaoCreditoLivre.outrasGarantias.push(new OutrasGarantias());
    }

    removerGarantia(i) {
        const operacaoCreditoLivre: OperacaoCreditoLivre = <OperacaoCreditoLivre>this.model;
        operacaoCreditoLivre.outrasGarantias.splice(i, 1);
    }
}